import React from 'react';
import { Tooltip as BaseTooltip, TooltipProps as BaseTooltipProps } from 'antd';

export type TooltipProps = BaseTooltipProps & {};

const Tooltip: React.FC<TooltipProps> = ({ ...props }) => <BaseTooltip {...props} />;

export default Tooltip;